import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo, useRef } from "react";
import ReactSelect, { components } from "react-select";
import classNames from "classnames";
import { ChevronDownIcon } from "@jti/brand-icons/chevron-down";
import { Button } from "../../../components/Button";
import { Checkbox } from "../../../components/Checkbox/Checkbox";
import { useTranslations } from "../../../providers/useTranslations";
import { InputWrapper } from "../components";
import styles from "./DropdownSelect.module.scss";
const DropdownIndicatorComponent = (props) => (_jsx(components.DropdownIndicator, { ...props, children: _jsx(ChevronDownIcon, {}) }));
const OptionComponent = (props) => {
    const { isSelected, label, data } = props;
    return (_jsx(components.Option, { ...props, children: _jsx(Checkbox, { onChange: () => { }, onTouchStart: () => { }, value: { checked: isSelected }, className: styles.dropdownCheckbox, labelHtml: label || data.name }) }));
};
const SelectMenuList = (props) => {
    const { __ } = useTranslations();
    const { onRestart, onApply, value, closeMenu, restartButtonText, applyButtonText } = props.selectProps;
    return (_jsxs(components.MenuList, { ...props, children: [_jsx("div", { className: "light-theme", children: props.children }), _jsxs("div", { className: styles.buttonsContainer, children: [_jsx(Button, { color: "secondary", onClick: () => {
                            onRestart();
                            closeMenu();
                        }, children: restartButtonText }), _jsx(Button, { color: "primary", onClick: () => {
                            onApply(value);
                            closeMenu();
                        }, children: applyButtonText })] })] }));
};
const ValueContainer = (props) => {
    const selectedItemsCount = props.getValue().length;
    const selectedInfo = selectedItemsCount ? `(${selectedItemsCount})` : "";
    return (_createElement(components.ValueContainer, { ...props, key: props.selectProps.key },
        props.children,
        `${props.selectProps.label} ${selectedInfo}`));
};
const PlaceholderComponent = () => null;
const MultiValueComponent = () => null;
const ReactSelectCustom = forwardRef((props, ref) => (_jsx(ReactSelect, { ...props, ref: ref })));
export const DropdownSelect = ({ id, helperText, dataTestId = "dropdownSelectInput", isHelperTextVisible = false, isError, errorText, isOptional, containerClassName, wrapperClassName, isIconHidden, isMulti = true, isSearchable = false, closeMenuOnSelect = false, hideSelectedOptions = false, ...rest }) => {
    const ref = useRef();
    const closeMenu = () => {
        if (ref.current)
            ref.current.blur();
    };
    const customComponents = useMemo(() => ({
        DropdownIndicator: DropdownIndicatorComponent,
        Option: OptionComponent,
        MenuList: SelectMenuList,
        ValueContainer: ValueContainer,
        Placeholder: PlaceholderComponent,
        MultiValue: MultiValueComponent,
        ClearIndicator: null,
    }), []);
    return (_jsx(InputWrapper, { htmlFor: id, errorText: errorText, helperText: helperText, isError: isError, isOptional: isOptional, dataTestId: `${dataTestId}-container`, containerClassName: classNames(containerClassName, styles.container), wrapperClassName: classNames(wrapperClassName, styles.wrapper), isHelperTextVisible: isHelperTextVisible, children: _jsx(ReactSelectCustom, { ref: ref, id: id, inputId: id, isOptionSelected: (option, selectValue) => {
                return !!selectValue.find((v) => v.key === option.key);
            }, "data-testid": dataTestId, className: classNames(styles.inputContainer, {
                [styles.containerError]: isError,
                [styles.hideIcon]: isIconHidden,
            }), classNamePrefix: "react-select", unstyled: true, closeMenuOnSelect: closeMenuOnSelect, hideSelectedOptions: hideSelectedOptions, isMulti: isMulti, isSearchable: isSearchable, blurInputOnSelect: false, backspaceRemovesValue: false, components: customComponents, closeMenu: closeMenu, ...rest }) }));
};
//# sourceMappingURL=DropdownSelect.js.map